
<div class="screen" [ngStyle]="{'background-color': backgroundColor() !== '' ? backgroundColor() : 'white'}" [ngClass]="{'hidden': !showSplashScreen}">
<img *ngIf="avatarClient() !== ''"
src="{{avatarClient()}}"
alt="Cliente logo">
<p *ngIf="avatarClient() === ''" style="font-size: 35px;">Estamos preparando todo para usted</p>
<div class="spinner">
<div class="bounce1" [ngStyle]="{'background-color': colorBounce() !== '' ? colorBounce() : 'black'}"></div>
<div class="bounce2" [ngStyle]="{'background-color': colorBounce() !== '' ? colorBounce() : 'black'}"></div>
<div class="bounce3" [ngStyle]="{'background-color': colorBounce() !== '' ? colorBounce() : 'black'}"></div>
</div>
</div>
